export default "__VITE_ASSET__CdbfiidS__"